import { JavaProvider } from '../models/JavaProvider';
import { JavaVulnerability } from '../models/JavaVulnerability';

export class JavaProviderMapper {
  mapGQLModel(data: any): JavaProvider[] {
    if (!data?.length) return [];

    return data.map((p: any, index: number) => {
      const vulnerabilities = p.vulnerabilities?.map((v: any) => new JavaVulnerability(v.name, v.url)) || [];
      return new JavaProvider(index, p.name, p.version, vulnerabilities);
    });
  }
}
